import { Dropdown, Input, Menu, Space, Col, Row } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { translate } from '@portal/services/i18n';
import DataTable from '@portal/components/DataTableStyled/DataTable';
import DetailDots from '@portal/assets/svg/manager-user/ic_detail_dots.svg?react';
import PlusIcon from '@portal/assets/svg/ic_plus.svg?react';

import { WL_COMPANY_PRIMARY_COLOR } from '@portal/config/env';

import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import useReduxState from '@portal/hooks/useReduxState';
import { useDispatch } from 'react-redux';
import { getRouteStackPath } from '@portal/config/routes';
import Header from '@portal/components/Header/Header';
import { listAllGroups } from '@portal/actions/group';
import { ListGroup } from '@portal/models/reducers';
import { useNavigation } from '@portal/hooks/useNavigation';

const initialValues: advancedFilterModels.baseFilter = {
  orderBy: 'createdAt',
  page: 0,
  pageSize: 10,
  sort: 'asc',
};

const ProfileManagerList = () => {
  const [onFocusSearch, setOnFocusSearch] = useState<boolean>(false);
  const [searchText, setSeachText] = useState<string>('');

  const [pageFilter, setPageFilter] =
    useState<advancedFilterModels.baseFilter>(initialValues);

  const LIMIT_FOR_PAGE = 5;
  const dispatch = useDispatch();

  const navigate = useNavigation();

  const {
    group: { myGroups, countGroup },
  } = useReduxState();

  useEffect(() => {
    if (searchText.length >= 3) {
      setTimeout(() => {
        dispatch(
          listAllGroups(
            LIMIT_FOR_PAGE,
            pageFilter.page,
            searchText.toLocaleLowerCase()
          )
        );
      }, 3000);
    }
  }, [dispatch, searchText, pageFilter.page]);

  useEffect(() => {
    if (searchText.length == 0) {
      dispatch(
        listAllGroups(
          LIMIT_FOR_PAGE,
          pageFilter.page,
          searchText.toLocaleLowerCase()
        )
      );
    }
  }, [searchText, pageFilter, dispatch]);

  const listUser = useMemo(() => {
    return myGroups.map((item): ListGroup => {
      return {
        ...item,
        numberOfOperators: item.numberOfOperators ?? '0',
      };
    });
  }, [myGroups]);

  const MenuSettings = (id: string) => (
    <Menu>
      <Menu.Item
        onClick={() =>
          navigate(getRouteStackPath('PROFILE_MANAGER', 'EDIT_PROFILE'), {
            state: {
              groupId: id,
            },
          })
        }
      >
        {translate('PAGES.PROFILE_MANAGER.BUTTONS_ACTIONS.EDIT')}
      </Menu.Item>
      <Menu.Item>
        {translate('PAGES.PROFILE_MANAGER.BUTTONS_ACTIONS.DELETE')}
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <Col className="manager-list">
        <Header subtitle={translate('PAGES.PROFILE_MANAGER.TITLE')} />

        <Row>
          <label className="manager-list__search__label" htmlFor="input-search">
            <Input
              id="input-search"
              value={searchText}
              onChange={(e) => setSeachText(e.target.value)}
              onFocus={() => setOnFocusSearch(true)}
              onBlur={() => setOnFocusSearch(false)}
              className="manager-list__search__input"
            />

            {!onFocusSearch && !searchText && (
              <span className="manager-list__search__input-placeholder">
                {translate('PAGES.PROFILE_MANAGER.SEARCH.PLACEHOLDER_PART_ONE')}
                <span className="manager-list__search__input-placeholder_color">
                  {' ' +
                    translate(
                      'PAGES.PROFILE_MANAGER.SEARCH.PLACEHOLDER_PART_TWO'
                    )}
                </span>
              </span>
            )}
          </label>

          <Col className="manager-list__search__select-type"></Col>

          <div style={{ flex: 1, height: 55, marginBottom: 20 }}>
            <AdvancedButton
              height="3.438rem"
              startIcon={<PlusIcon style={{ marginLeft: '-30px' }} />}
              fullWidth={true}
              onClick={() =>
                navigate(getRouteStackPath('PROFILE_MANAGER', 'NEW_PROFILE'))
              }
              text={translate('PAGES.PROFILE_MANAGER.SEARCH.NEW_USER')}
            />
          </div>
        </Row>

        <div>
          <DataTable
            orderBy={initialValues.orderBy}
            sort={initialValues.sort}
            pageSize={LIMIT_FOR_PAGE}
            columns={[
              {
                field: 'name',
                flex: 1,
                headerName: translate('PAGES.PROFILE_MANAGER.TABLE_GROUP.NAME'),
                sortable: false,
                hide: false,
                renderHeader: () => (
                  <div
                    style={{ color: WL_COMPANY_PRIMARY_COLOR }}
                    className="manager-list__header-text"
                  >
                    Grupos
                  </div>
                ),
              },
              {
                field: 'numberOfOperators',
                flex: 1,
                headerName: translate(
                  'PAGES.PROFILE_MANAGER.TABLE_GROUP.NUMBER_OF_OPERATORS'
                ),
                sortable: false,
                hide: false,
                renderHeader: () => (
                  <div
                    style={{ color: WL_COMPANY_PRIMARY_COLOR }}
                    className="manager-list__header-text"
                  >
                    Quantidade Operadores
                  </div>
                ),
              },
              {
                field: 'details',
                flex: 1,
                headerName: translate(
                  'PAGES.PROFILE_MANAGER.TABLE_GROUP.DETAILS'
                ),
                sortable: false,
                hide: false,
                renderHeader: () => (
                  <div
                    style={{ color: WL_COMPANY_PRIMARY_COLOR }}
                    className="manager-list__header-text"
                  >
                    Detalhes
                  </div>
                ),
                renderCell: (params) => (
                  <Dropdown
                    overlay={MenuSettings(params.row.id)}
                    trigger={['click']}
                  >
                    <a onClick={(e) => e.preventDefault()}>
                      <Space>
                        <DetailDots />
                      </Space>
                    </a>
                  </Dropdown>
                ),
              },
            ]}
            rows={listUser ?? []}
            rowCount={countGroup ?? LIMIT_FOR_PAGE}
            onChange={(info) => setPageFilter(info)}
          />
        </div>
      </Col>
    </div>
  );
};

export default ProfileManagerList;
